import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../../../services/api/api.service';
import { NbToastrService } from '@nebular/theme';
import { DynamicDialogRef } from 'primeng/api';

@Component({
  selector: 'app-password-expired',
  templateUrl: './password-expired.component.html',
  styleUrls: ['./password-expired.component.css']
})
export class PasswordExpiredComponent implements OnInit {
  public model: any = {};
  public loading: boolean = false;
  public errors: any = new Array();
  constructor(private apiService?: ApiService,
    private messageService?: NbToastrService, public ref?: DynamicDialogRef) { }

  ngOnInit() {
  }


  public updatePassword() {
    this.loading = true;
    this.errors = new Array();;
    this.apiService.post(`/api/User/changePassword`, this.model)
      .subscribe(o => {
        this.loading = false;
        this.ref.close();
        this.messageService.success('Password Updated', 'Password successfully updated');
      }, err => {
        this.loading = false;
        var errors = new Array();
        var keys = Object.keys(err.error).forEach(key => {
         // if (key) {
            console.log(key);
            errors.push({ key: key, errors: err.error[key] })
         // }
        });
          this.errors = errors;
      })
  }
}
